/**
 * The game's name (`02_decisions_log.md` §2, D-01: "Fairway Life", the working title).
 *
 * It lives here and nowhere else in code. Player-facing text names the game through the
 * `{gameName}` token of `@fairway/content`, so a change of name after the trade mark search
 * (`28` LEG-200) is one line.
 */
export const GAME_NAME = 'Fairway Life';
